export const RequestTypes = Object.freeze({
    GET: Symbol("GET"),
    POST: Symbol("POST"),
    PUT: Symbol("PUT"),
    DELETE: Symbol("DELETE")
});